import React from 'react';
import { createRoot } from 'react-dom/client';
import providerHOC from '../utils/providerHOC/providerHOC';
import subscriptionForm from '../commonComponents/molecules/subscriptionForm';
import subscriptionPageHOC from './subscriptionPageHOC';

const SubscriptionPageRoot = providerHOC()(subscriptionPageHOC(subscriptionForm));
createRoot(document.getElementById('subscriptionPage')).render(<SubscriptionPageRoot />);
